import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import { constantsActive } from 'utils/constants/constants'
import QueryReports from 'graphql/queries/QueryReports'
import QueryReport from 'graphql/queries/QueryReport'

export default class FetchReports {
	
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'reports', QueryReports, {
			variables: {
				active: [
					constantsActive.YES,
					constantsActive.NO,
				]
			},
			resultPath: [ 'reports' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
	
	static fetch( { guid = null, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'report', QueryReport, {
			variables: {
				guid: guid
			},
			resultPath: [ 'report' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
}
